import { createContext, useContext, type ReactNode } from "react";

const ShellPortalContext = createContext<HTMLElement | null>(null);

export function ShellPortalProvider({
  container,
  children,
}: {
  container: HTMLElement;
  children: ReactNode;
}) {
  return (
    <ShellPortalContext.Provider value={container}>
      {children}
    </ShellPortalContext.Provider>
  );
}

export function useShellPortalContainer(): HTMLElement | null {
  return useContext(ShellPortalContext);
}
